import { FaBell, FaEnvelope, FaMobileAlt } from "react-icons/fa";
import Toggle from "modules/swiftboard/components/ui/Toggle";
import { SectionShell, ToggleRow } from "./settings-shared";

const PROJECT_NOTIFICATIONS = [
  { key: "notify_project_assigned", label: "Project assigned", description: "When you're added to a project" },
  { key: "notify_project_completed", label: "Project completed", description: "When a project you're on is marked complete" },
  { key: "notify_project_comment", label: "New comments", description: "When someone comments on your project" },
  { key: "notify_project_due", label: "Deadline reminders", description: "When a project deadline is approaching" },
  { key: "notify_project_updates", label: "Project updates", description: "Status changes and milestone updates" },
  { key: "notify_mentions", label: "Mentions", description: "When someone @mentions you" },
];

const DIGEST_NOTIFICATIONS = [
  { key: "notify_daily_summary", label: "Daily summary", description: "A daily digest of your project activity" },
  { key: "notify_weekly_summary", label: "Weekly summary", description: "A weekly digest of your project activity" },
];

export default function NotificationsSection({ formData, onChange }) {
  return (
    <SectionShell id="notifications" icon={FaBell} title="Notifications" subtitle="Choose what you get notified about">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pb-4 mb-1 border-b border-border/60">
        <ToggleRow label="Email notifications" description="Master switch for all email alerts">
          <div className="flex items-center gap-2 shrink-0">
            <FaEnvelope size={12} className="text-text_muted" />
            <Toggle checked={!!formData.email_notifications} onChange={(v) => onChange("email_notifications", v)} />
          </div>
        </ToggleRow>
        <ToggleRow label="Push notifications" description="Master switch for browser/app push alerts">
          <div className="flex items-center gap-2 shrink-0">
            <FaMobileAlt size={12} className="text-text_muted" />
            <Toggle checked={!!formData.push_notifications} onChange={(v) => onChange("push_notifications", v)} />
          </div>
        </ToggleRow>
      </div>

      <p className="text-[11px] font-semibold text-text_muted uppercase tracking-wide mb-1">Project activity</p>
      {PROJECT_NOTIFICATIONS.map(({ key, label, description }) => (
        <ToggleRow key={key} label={label} description={description}>
          <Toggle checked={!!formData[key]} onChange={(v) => onChange(key, v)} />
        </ToggleRow>
      ))}

      <p className="text-[11px] font-semibold text-text_muted uppercase tracking-wide mt-4 mb-1">Digests</p>
      {DIGEST_NOTIFICATIONS.map(({ key, label, description }) => (
        <ToggleRow key={key} label={label} description={description}>
          <Toggle checked={!!formData[key]} onChange={(v) => onChange(key, v)} />
        </ToggleRow>
      ))}
    </SectionShell>
  );
}
